import React, { useEffect, useState } from 'react';
import filterClose from '../../../Assets/Images/filterClose.svg';
import filterOpen from '../../../Assets/Images/filter-open.svg';
import filterUser from '../../../Assets/Images/filter-user.png';
import filterTune from '../../../Assets/Images/filter-tune.png';
import searchIcon from '../../../Assets/Images/FilterSearchIcon.png';
import { Button, TextField, InputAdornment } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import CheckboxFilters from './CheckboxFilters';
import { INFINITY } from 'chart.js/helpers';

export default function Filter({ onClose, handleOpen, filterBoxOpened, handleCheckboxChange, checkboxStates, total, count, dataFilters, filtersApplied, clearFilters, gender, setGender, setFilteredMinAge, setFilteredMaxAge, filteredMinAge, filteredMaxAge }) {
  const [minAge, setMinAge] = useState(!filteredMinAge ? '' : filteredMinAge);
  const [maxAge, setMaxAge] = useState(!filteredMaxAge ? '' : filteredMaxAge);
  const [error, setError] = useState('');

  const handleMinAgeChange = (event) => {
    const value = event.target.value;
    if (value === '' || !(/^\d*$/.test(value))) {
      setMinAge('');
      setError('');
      setFilteredMinAge(null);
      return;
    }
    const num = parseInt(value, 10);
    setMinAge(num);
    if (value < 0 || (maxAge && value >= maxAge)) {
      setError('Min age must be greater than 0 and less than max age');
    } else {
      setError('');
      setFilteredMinAge(num);
    }
  };

  const handleMaxAgeChange = (event) => {
    const value = event.target.value;
    if (value === '' || !(/^\d*$/.test(value))) {
      setMaxAge('');
      setError('');
      setFilteredMaxAge(null);
      return;
    }
    const num = parseInt(value, 10);
    setMaxAge(num);
    if (value <= minAge || value > 99) {
      setError('Max age must be greater than or equal to min age and less than or equal to 99');
    } else {
      setError('');
      setFilteredMaxAge(num);
      return;
    }
  };

  useEffect(() => {
    if(!filteredMinAge){
      setMinAge('');
    }
    if(!filteredMaxAge){
      setMaxAge('');
    }
  }, [filteredMinAge, filteredMaxAge])
  return (
    <div className='filter-container' style={{ maxWidth: filterBoxOpened ? '360px' : '80px' }}>
      {filterBoxOpened ? <div className='content'>
        <div className='header'>
          <div className='heading'>
            <h5>Filters</h5>
            <img src={filterClose} alt="filter Close" width={43} height={24} onClick={onClose} className='close-btn' />
          </div>
          <div className='heading-description'>
            <div className='desc'>
              <div className='first'>
                <img src={filterTune} alt="filter tune icon" width={20} height={20} />
                <p><span>{filtersApplied}</span> FITLERS APPLIED</p>
              </div>
              <Button onClick={() => clearFilters()}>RESET</Button>
            </div>
            <div className='desc'>
              <div className='first'>
                <img src={filterUser} alt="filter User icon" width={20} height={20} />
                <p><span>{count}</span> OF <span>{total}</span> CONGREGANTS</p>
              </div>
              <Button onClick={() => clearFilters()}>RESET</Button>
            </div>
          </div>
        </div>
        <div className='sub-header'>
          <div className='sub-h'>
            <h6>GENDER</h6>
            <div className='button-container'>
              <Button className={`gender-button ${gender==='male' ? 'active-gender' : ''}`} onClick={() => setGender(gender => gender === 'male' ? null : 'male')}>MALE</Button>
              <Button className={`gender-button ${gender==='female' ? 'active-gender' : ''}`} onClick={() => setGender(gender => gender === 'female' ? null : 'female')}>FEMALE</Button>
            </div>
          </div>
          <div className='sub-h'>
            <h6>AGE</h6>
            <div className="button-container">
              <div className="btn">
                <p>MIN</p>
                <input type="text" value={minAge} onChange={handleMinAgeChange} />
              </div>
              <div className="btn">
                <p>MAX</p>
                <input type="text" value={maxAge} onChange={handleMaxAgeChange} />
              </div>
            </div>
          </div>
          {error && <p className="error">{error}</p>}
        </div>
        {
          dataFilters.map(filter =>
            <CheckboxFilters key={filter.id} filter={filter} handleCheckboxChange={handleCheckboxChange} checkboxStates={checkboxStates} />)
        }
      </div> :
        <div className='small-content'>
          <img src={filterOpen} alt="filter Open" width={16} height={24} onClick={handleOpen} className='close-btn' />
          <div className='rotated-box'>
            <p className="filters-text"><span>{filtersApplied}</span> Filters Applied</p>
          </div>
          <div className='rotated-box'>
            <p className="filters-text"><span>{count}</span> of <span>{total}</span> congregants</p>
          </div>
        </div>}
    </div>
  )
}
